"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class EventApi extends runtime.BaseAPI {
    /**
     */
    apiEventAttendCheckInByAttendanceCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckInByAttendanceCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventByCodeRequestToJSON(requestParameters.apiEventByCodeRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckInByAttendanceCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckInByAttendanceCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckInByPersonCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckInByPersonCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventByPersonRequestToJSON(requestParameters.apiEventByPersonRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckInByPersonCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckInByPersonCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckInMultiplePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckInMultiple`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceMultipleRequestToJSON(requestParameters.apiEventAttendanceMultipleRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttendanceResponseIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckInMultiplePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckInMultiplePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckInPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckIn`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceRequestToJSON(requestParameters.apiEventAttendanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckInPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckInPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckOutByAttendanceCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckOutByAttendanceCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventByCodeRequestToJSON(requestParameters.apiEventByCodeRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckOutByAttendanceCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckOutByAttendanceCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckOutByPersonCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckOutByPersonCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventByPersonRequestToJSON(requestParameters.apiEventByPersonRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckOutByPersonCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckOutByPersonCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckOutMultiplePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckOutMultiple`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceMultipleRequestToJSON(requestParameters.apiEventAttendanceMultipleRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttendanceResponseIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckOutMultiplePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckOutMultiplePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendCheckOutPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/CheckOut`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceRequestToJSON(requestParameters.apiEventAttendanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendCheckOutPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendCheckOutPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Person unique code is ignored for this call, as it is not suppored from kiosk mode
     */
    apiEventAttendGetForEventAndPersonPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/GetForEventAndPerson`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceRequestToJSON(requestParameters.apiEventAttendanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Person unique code is ignored for this call, as it is not suppored from kiosk mode
     */
    apiEventAttendGetForEventAndPersonPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendGetForEventAndPersonPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendListForEventPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/ListForEvent`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendListForEventPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendListForEventPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists possible attendees that are invited. Note that for open events this will return empty for AwaitingRsvp. You may request unpaged results.
     */
    apiEventAttendListInvitedPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/ListInvited`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityPagedRequestToJSON(requestParameters.apiEntityPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PossibleAttendeesResponsePagedRawResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists possible attendees that are invited. Note that for open events this will return empty for AwaitingRsvp. You may request unpaged results.
     */
    apiEventAttendListInvitedPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendListInvitedPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists possible attendees that you have rights to check in. For kiosk purposes, pass in the person unique code as well - current user will only be checked for Operate rights
     */
    apiEventAttendListPossiblePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/ListPossible`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPossibleAttendeeRequestToJSON(requestParameters.apiPossibleAttendeeRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PossibleAttendeesResponsePagedRawResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists possible attendees that you have rights to check in. For kiosk purposes, pass in the person unique code as well - current user will only be checked for Operate rights
     */
    apiEventAttendListPossiblePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendListPossiblePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * All events that you (or those you own) are attending but not yet checked in to
     */
    apiEventAttendListRegisteredPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/ListRegistered`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRawPagedRequestToJSON(requestParameters.apiRawPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceHasMoreResponseFromJSON(jsonValue));
        });
    }
    /**
     * All events that you (or those you own) are attending but not yet checked in to
     */
    apiEventAttendListRegisteredPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendListRegisteredPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists possible attendees that are invited and are still to RSVP. For open events, this will return empty. You can request unpaged.
     */
    apiEventAttendListRsvpPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/ListRsvp`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityPagedRequestToJSON(requestParameters.apiEntityPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IPersonPagedResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists possible attendees that are invited and are still to RSVP. For open events, this will return empty. You can request unpaged.
     */
    apiEventAttendListRsvpPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendListRsvpPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendMaybePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Maybe`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceRequestToJSON(requestParameters.apiEventAttendanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendMaybePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendMaybePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendNoPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/No`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceRequestToJSON(requestParameters.apiEventAttendanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendNoPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendNoPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendReportAbsentDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Absent/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventAttendReportAbsentDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventAttendReportAbsentDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiEventAttendReportAbsentListForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Absent/ListForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendReportAbsentListForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendReportAbsentListForGroupTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     */
    apiEventAttendReportAbsentListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Absent/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     */
    apiEventAttendReportAbsentListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendReportAbsentListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The Filters collection will filter the Events, the property filters will filter Persons. Open events will not be listed as absence cannot be known for Open events. This only reports on person invited to an event who did NOT rsvp. To get a count of those who RSVPd but did not attend, use an Attendance report
     */
    apiEventAttendReportAbsentRunPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Absent/Run`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReportResponseFromJSON(jsonValue));
        });
    }
    /**
     * The Filters collection will filter the Events, the property filters will filter Persons. Open events will not be listed as absence cannot be known for Open events. This only reports on person invited to an event who did NOT rsvp. To get a count of those who RSVPd but did not attend, use an Attendance report
     */
    apiEventAttendReportAbsentRunPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendReportAbsentRunPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendReportAbsentSaveForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Absent/SaveForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventAttendReportAbsentSaveForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventAttendReportAbsentSaveForGroupTypePostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventAttendReportAbsentSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Absent/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventAttendReportAbsentSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventAttendReportAbsentSavePostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventAttendReportDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventAttendReportDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventAttendReportDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiEventAttendReportListForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/ListForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendReportListForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendReportListForGroupTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     */
    apiEventAttendReportListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     */
    apiEventAttendReportListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendReportListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The Filters collection will filter the Events
     */
    apiEventAttendReportRunPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Run`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReportResponseFromJSON(jsonValue));
        });
    }
    /**
     * The Filters collection will filter the Events
     */
    apiEventAttendReportRunPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendReportRunPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendReportSaveForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/SaveForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventAttendReportSaveForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventAttendReportSaveForGroupTypePostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventAttendReportSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Report/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventAttendReportSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventAttendReportSavePostRaw(requestParameters);
        });
    }
    /**
     * This runs a multiple attend yes
     */
    apiEventAttendYesMultiplePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/YesMultiple`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceMultipleRequestToJSON(requestParameters.apiEventAttendanceMultipleRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttendanceResponseIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * This runs a multiple attend yes
     */
    apiEventAttendYesMultiplePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendYesMultiplePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventAttendYesPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Attend/Yes`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventAttendanceRequestToJSON(requestParameters.apiEventAttendanceRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventAttendYesPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventAttendYesPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiEventFavouriteAddPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Favourite/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventFavouriteAddPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventFavouriteAddPostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventFeedbackGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Feedback/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventFeedbackGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventFeedbackGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventFeedbackPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Feedback`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiAddReplyRequestToJSON(requestParameters.apiAddReplyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventFeedbackPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventFeedbackPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventGetByCodePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/GetByCode`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventByCodeRequestToJSON(requestParameters.apiEventByCodeRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventGetByCodePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventGetByCodePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiEventImportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.importIdentifier !== undefined) {
                queryParameters['importIdentifier'] = requestParameters.importIdentifier;
            }
            if (requestParameters.createDependencies !== undefined) {
                queryParameters['createDependencies'] = requestParameters.createDependencies;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Event/Import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IImportIStorableFromJSON(jsonValue));
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiEventImportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventImportPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventListForGroupPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/ListForGroup`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventRequestToJSON(requestParameters.apiEventRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventIEnumerableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventListForGroupPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventListForGroupPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists all events that the current person can manage (write access). Note that this is \'as of now\' and any date in the past is used as a start point rather than a point-in-time
     */
    apiEventListManagedPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/ListManaged`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToToJSON(requestParameters.apiRequestTo),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists all events that the current person can manage (write access). Note that this is \'as of now\' and any date in the past is used as a start point rather than a point-in-time
     */
    apiEventListManagedPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventListManagedPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventListOpenEntityIdFromToGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entityId === null || requestParameters.entityId === undefined) {
                throw new runtime.RequiredError('entityId', 'Required parameter requestParameters.entityId was null or undefined when calling apiEventListOpenEntityIdFromToGet.');
            }
            if (requestParameters.from === null || requestParameters.from === undefined) {
                throw new runtime.RequiredError('from', 'Required parameter requestParameters.from was null or undefined when calling apiEventListOpenEntityIdFromToGet.');
            }
            if (requestParameters.to === null || requestParameters.to === undefined) {
                throw new runtime.RequiredError('to', 'Required parameter requestParameters.to was null or undefined when calling apiEventListOpenEntityIdFromToGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/ListOpen/{entityId}/{from}/{to}`.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters.entityId))).replace(`{${"from"}}`, encodeURIComponent(String(requestParameters.from))).replace(`{${"to"}}`, encodeURIComponent(String(requestParameters.to))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.EventSummaryResponseFromJSON));
        });
    }
    /**
     */
    apiEventListOpenEntityIdFromToGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventListOpenEntityIdFromToGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventListOpenForHighlightedFromToGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.from === null || requestParameters.from === undefined) {
                throw new runtime.RequiredError('from', 'Required parameter requestParameters.from was null or undefined when calling apiEventListOpenForHighlightedFromToGet.');
            }
            if (requestParameters.to === null || requestParameters.to === undefined) {
                throw new runtime.RequiredError('to', 'Required parameter requestParameters.to was null or undefined when calling apiEventListOpenForHighlightedFromToGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/ListOpenForHighlighted/{from}/{to}`.replace(`{${"from"}}`, encodeURIComponent(String(requestParameters.from))).replace(`{${"to"}}`, encodeURIComponent(String(requestParameters.to))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.EventSummaryResponseFromJSON));
        });
    }
    /**
     */
    apiEventListOpenForHighlightedFromToGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventListOpenForHighlightedFromToGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Before an occurrence of an event series can be used, it must be \'materialized\' to turn it into a full event
     */
    apiEventMaterializePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Materialize`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventMaterializeRequestToJSON(requestParameters.apiEventMaterializeRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     * Before an occurrence of an event series can be used, it must be \'materialized\' to turn it into a full event
     */
    apiEventMaterializePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventMaterializePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventNoteGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Note/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventNoteGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventNoteGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventNoteListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Note/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorablePagedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventNoteListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventNoteListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventNotePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Note`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiAddNoteRequestToJSON(requestParameters.apiAddNoteRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.INoteIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventNotePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventNotePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Sends a notification to all possible attendees (plus anyone additional listed in the ToPersonEntityId field). For Open events it sends a message to everyone who is a member of the same organization as the event.
     */
    apiEventNotificationSendAllPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Notification/SendAll`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventNotificationRequestToJSON(requestParameters.apiEventNotificationRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Sends a notification to all possible attendees (plus anyone additional listed in the ToPersonEntityId field). For Open events it sends a message to everyone who is a member of the same organization as the event.
     */
    apiEventNotificationSendAllPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventNotificationSendAllPostRaw(requestParameters);
        });
    }
    /**
     * Sends a notification to all registered attendees (plus anyone additional listed in the ToPersonEntityId field).
     */
    apiEventNotificationSendAttendeesPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Notification/SendAttendees`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventNotificationRequestToJSON(requestParameters.apiEventNotificationRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Sends a notification to all registered attendees (plus anyone additional listed in the ToPersonEntityId field).
     */
    apiEventNotificationSendAttendeesPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventNotificationSendAttendeesPostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventPositionAcceptPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Accept`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionAssignIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventPositionAcceptPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionAcceptPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Leave the ToPersonEntityId blank to use the current person. You can only assign people to event positions, not event series positions
     */
    apiEventPositionAssignPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Assign`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.EventPositionAssignConstructToJSON(requestParameters.eventPositionAssignConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionAssignIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Leave the ToPersonEntityId blank to use the current person. You can only assign people to event positions, not event series positions
     */
    apiEventPositionAssignPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionAssignPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventPositionAssignedPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Assigned`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionAssignIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventPositionAssignedPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionAssignedPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Checks any block out for given person and date given at Point In Time. Note that point in time is NOT historical for this call
     */
    apiEventPositionBlockCheckByDatePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Block/CheckByDate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiCheckBlockRequestToJSON(requestParameters.apiCheckBlockRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionBlockIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Checks any block out for given person and date given at Point In Time. Note that point in time is NOT historical for this call
     */
    apiEventPositionBlockCheckByDatePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionBlockCheckByDatePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Checks any block out for given person and event
     */
    apiEventPositionBlockCheckPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Block/Check`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPersonRequestToJSON(requestParameters.apiPersonRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionBlockIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Checks any block out for given person and event
     */
    apiEventPositionBlockCheckPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionBlockCheckPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a block out for the current person
     */
    apiEventPositionBlockEntityIdDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.entityId === null || requestParameters.entityId === undefined) {
                throw new runtime.RequiredError('entityId', 'Required parameter requestParameters.entityId was null or undefined when calling apiEventPositionBlockEntityIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Position/Block/{entityId}`.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters.entityId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a block out for the current person
     */
    apiEventPositionBlockEntityIdDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventPositionBlockEntityIdDeleteRaw(requestParameters);
        });
    }
    /**
     * Gets all blocked out for current person
     */
    apiEventPositionBlockGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Position/Block`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionBlockIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets all blocked out for current person
     */
    apiEventPositionBlockGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionBlockGetRaw();
            return yield response.value();
        });
    }
    /**
     * Upserts a block out for current person
     */
    apiEventPositionBlockPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Block`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.EventPositionBlockConstructToJSON(requestParameters.eventPositionBlockConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionBlockIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Upserts a block out for current person
     */
    apiEventPositionBlockPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionBlockPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventPositionDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Position/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventPositionDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventPositionDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiEventPositionListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventPositionListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventPositionPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.EventPositionConstructToJSON(requestParameters.eventPositionConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventPositionIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventPositionPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes an event position assignment - can only be called by event writers/operators or the person themselves
     */
    apiEventPositionUnassignPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Unassign`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRawRequestToJSON(requestParameters.apiEntityRawRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes an event position assignment - can only be called by event writers/operators or the person themselves
     */
    apiEventPositionUnassignPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventPositionUnassignPostRaw(requestParameters);
        });
    }
    /**
     * Lists all event positions for the current person for the next 2 months after the specified date. This is \'as of now\' and any date in the past is used as a start point rather than a point-in-time
     */
    apiEventPositionUpcomingPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Position/Upcoming`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EventPositionsUpcomingResponseIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists all event positions for the current person for the next 2 months after the specified date. This is \'as of now\' and any date in the past is used as a start point rather than a point-in-time
     */
    apiEventPositionUpcomingPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPositionUpcomingPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Note that when materializing event series occurrences using this method, event positions will not be filled automatically.
     */
    apiEventPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.EventConstructToJSON(requestParameters.eventConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     * Note that when materializing event series occurrences using this method, event positions will not be filled automatically.
     */
    apiEventPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventReportDeleteDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Report/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventReportDeleteDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventReportDeleteDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiEventReportListForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Report/ListForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventReportListForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventReportListForGroupTypePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventReportListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Report/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IReportIStorableIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventReportListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventReportListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventReportRunPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Report/Run`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReportResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventReportRunPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventReportRunPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventReportSaveForGroupTypePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Report/SaveForGroupType`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventReportSaveForGroupTypePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventReportSaveForGroupTypePostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventReportSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Report/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ReportConstructToJSON(requestParameters.reportConstruct),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventReportSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventReportSavePostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventResourceDeletePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Resource/Delete`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventResourceDeletePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventResourceDeletePostRaw(requestParameters);
        });
    }
    /**
     */
    apiEventResourceFilePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Resource/File`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventResourceFilePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventResourceFilePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventResourceListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Resource/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityFilteredPagedRequestToJSON(requestParameters.apiEntityFilteredPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IResourceIStorablePagedSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiEventResourceListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventResourceListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets a resource file for an event. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiEventResourceResourceEntityIdFileNameGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.resourceEntityId === null || requestParameters.resourceEntityId === undefined) {
                throw new runtime.RequiredError('resourceEntityId', 'Required parameter requestParameters.resourceEntityId was null or undefined when calling apiEventResourceResourceEntityIdFileNameGet.');
            }
            if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
                throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling apiEventResourceResourceEntityIdFileNameGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Resource/{resourceEntityId}/{fileName}`.replace(`{${"resourceEntityId"}}`, encodeURIComponent(String(requestParameters.resourceEntityId))).replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters.fileName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     * Gets a resource file for an event. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiEventResourceResourceEntityIdFileNameGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventResourceResourceEntityIdFileNameGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Gets a resource file for an event. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiEventResourceResourceEntityIdGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.resourceEntityId === null || requestParameters.resourceEntityId === undefined) {
                throw new runtime.RequiredError('resourceEntityId', 'Required parameter requestParameters.resourceEntityId was null or undefined when calling apiEventResourceResourceEntityIdGet.');
            }
            const queryParameters = {};
            if (requestParameters.fileName !== undefined) {
                queryParameters['fileName'] = requestParameters.fileName;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Resource/{resourceEntityId}`.replace(`{${"resourceEntityId"}}`, encodeURIComponent(String(requestParameters.resourceEntityId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StreamFromJSON(jsonValue));
        });
    }
    /**
     * Gets a resource file for an event. This call does not support point in time. For point in time requests, use [POST]Resource/File
     */
    apiEventResourceResourceEntityIdGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventResourceResourceEntityIdGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     */
    apiEventResourceSavePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.resourceJson !== undefined) {
                queryParameters['resourceJson'] = requestParameters.resourceJson;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Event/Resource/Save`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IResourceIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     */
    apiEventResourceSavePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventResourceSavePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiEventRestorePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Event/Restore`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiEventRestorePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiEventRestorePostRaw(requestParameters);
        });
    }
    /**
     * Gets types of ticket valid for a given event (entity id) and list of people
     */
    apiEventTicketListTypesPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Ticket/ListTypes`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiTicketTypeRequestToJSON(requestParameters.apiTicketTypeRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GuidITicketTypeIEnumerableDictionaryIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets types of ticket valid for a given event (entity id) and list of people
     */
    apiEventTicketListTypesPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventTicketListTypesPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Reserves a ticket for 15 minutes, pass the event entity id as EntityID and the ticket type entity id as TicketTypeEntityId
     */
    apiEventTicketReservePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Ticket/Reserve`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiTicketRequestToJSON(requestParameters.apiTicketRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IEventAttendanceIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Reserves a ticket for 15 minutes, pass the event entity id as EntityID and the ticket type entity id as TicketTypeEntityId
     */
    apiEventTicketReservePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventTicketReservePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists all events for the current person for the next 2 months after the specified date. This is \'as of now\' and any date in the past is used as a start point rather than a point-in-time
     */
    apiEventUpcomingPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Event/Upcoming`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEventsUpcomingRequestToJSON(requestParameters.apiEventsUpcomingRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EventsUpcomingResponseIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists all events for the current person for the next 2 months after the specified date. This is \'as of now\' and any date in the past is used as a start point rather than a point-in-time
     */
    apiEventUpcomingPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiEventUpcomingPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.EventApi = EventApi;
